import React, {Component} from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import Dropzone from "react-dropzone"
import {Row, Col} from "react-bootstrap"
import browserImageSize from "browser-image-size"

import Loading from "@irati/ui/src/Loading"
import {Input} from "@irati/ui/src/FormItem"

import {H4} from "@irati/ui/src/Headings"
import padding from "@irati/ui/src/global/padding"
import ErrorText from "@irati/ui/src/ErrorText"
import newId from "@irati/utils/id"
import getBase64 from "@irati/utils/images/getBase64"
import {uploadImage} from "@irati/images/services/image"

import withRewardOnChange from "./withRewardOnChange"

const StyledRow = styled(Row)`
  margin-bottom: ${padding.small};
`

const StyledImage = styled.img`
  max-width: 80%;
  `

class UploadImage extends Component {
  static propTypes = {
    reward: PropTypes.object.isRequired,
    property: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    dimensions: PropTypes.object
  }

  static defaultProps = {
    property: "thumbnailImage",
    label: "Upload thumbnail image:",
    id: "uploadImage",
    dimensions: null
  }

  constructor(props) {
    super(props)
    this.state = {

    }
  }

  handleUpload = (file) => {
    const {reward, property, onChange} = this.props
    return uploadImage(file).then((imgUrl) => {
      onChange(reward, property, imgUrl)
    })
  }

  handleDrop = (acceptedFile, rejectedFile) => {
    const {dimensions} = this.props
    if (rejectedFile.length > 0) {
      this.setState({fileError: "Wrong file type. Please upload image using jpg/jpeg format."})
    } else {
      return getBase64(acceptedFile[0]).then((base64Image) => {
        const load = browserImageSize(base64Image).then((size) => {
          if (dimensions && (dimensions.width !== size.width || dimensions.height !== size.height)) {
            this.setState({
              fileError: `Wrong file dimensions. File must be ${dimensions.width}px by ${dimensions.height}px.`
            })
          } else {
            return this.handleUpload(base64Image)
          }
        })
        this.setState({load, fileError: null})
      })
    }
  }

  render() {
    const {reward, label, property, dimensions} = this.props
    const {load, fileError} = this.state
    let hint
    if (dimensions) {
      hint = `Dimensions must be ${dimensions.width}px by ${dimensions.height}px`
    }

    return (
      <div>
        <Row>
          <Col xs={12}>
            <H4 small>{label}</H4>
          </Col>
        </Row>
        <StyledRow>
          <Col xs={3}>
            <Dropzone
              id={newId("dropzone", this.props)}
              name={newId("dropzone", this.props)}
              accept="image/jpg,image/jpeg"
              onDrop={this.handleDrop}>
              <p>Drop image file here or click to select image to upload and the uploaded link will show below.</p>
            </Dropzone>
          </Col>
          <Col xs={9}>
            {reward[property] &&
            <StyledImage id={newId("image", this.props)} src={reward[property]} />
            }
          </Col>
        </StyledRow>
        {fileError && <ErrorText id={newId("error", this.props)}>{fileError}</ErrorText>}
        <Loading load={load} />
        <StyledRow>
          <Col xs={12}>
            <Input hint={hint} id={newId("value", this.props)} type="text" disabled value={reward[property] || ""} />
          </Col>
        </StyledRow>
      </div>
    )
  }
}

export default withRewardOnChange(UploadImage)
